import angular from 'angular';
import uiRouter from 'angular-ui-router';
import unitauditComponent from './unitaudit.component';

let unitauditModule = angular.module('unitaudit', [
  uiRouter
])

.component('unitaudit', unitauditComponent);

export default unitauditModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/unitaudit/unitaudit.js